export default __webpack_public_path__ + "static/media/episode-03.0caa1ac1.webp";